var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1756462468796,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 6137,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 64L128 224v320c0 224 160 384 384 448 224-64 384-224 384-448V224L512 64z m320 480c0 176-128 304-320 368-192-64-320-192-320-368V262.4l320-128 320 128V544z",
    fill: "#ffffff",
    "p-id": 6138
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 256L256 352v192c0 128 96 224 256 288 160-64 256-160 256-288V352L512 256z m192 288c0 96-80 176-192 224-112-48-192-128-192-224v-147.2l192-76.8 192 76.8V544z",
    fill: "#ffffff",
    "p-id": 6139
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPrivacy);
export default __webpack_public_path__ + "static/media/ic_privacy.1280741a6c814bfb7730f9bd6bf10608.svg";
export { ForwardRef as ReactComponent };